import { apiClient } from '@/shared/services/client'
import type {
  DashboardConfigResponse,
  DashboardEstadisticas,
  DashboardTablaDatos,
  DashboardGraficos,
  DashboardFiltroOpciones,
  UsuarioResumen,
  BusquedaCrossDB,
  ComprobanteDetalle,
} from '../types'

const BASE_URL = '/registros/dashboard'

export const dashboardApi = {
  getConfig: async (grupoId: string): Promise<DashboardConfigResponse> => {
    const { data } = await apiClient.get(`${BASE_URL}/${grupoId}/`)
    return data
  },

  getEstadisticas: async (
    grupoId: string,
    filtros?: {
      fecha_desde?: string
      fecha_hasta?: string
      farmacia?: string
      provincia?: string
      promotor?: string
    }
  ): Promise<DashboardEstadisticas> => {
    const { data } = await apiClient.get(`${BASE_URL}/${grupoId}/estadisticas/`, {
      params: filtros,
    })
    return data
  },

  getTablaDatos: async (
    grupoId: string,
    configId: number,
    params?: {
      page?: number
      page_size?: number
      ordenar_por?: string
      busqueda?: string
      fecha_desde?: string
      fecha_hasta?: string
      farmacia?: string
      provincia?: string
      promotor?: string
      todos?: boolean
    }
  ): Promise<DashboardTablaDatos> => {
    const { data } = await apiClient.get(
      `${BASE_URL}/${grupoId}/tabla/${configId}/datos/`,
      { params }
    )
    return data
  },

  getGraficos: async (
    grupoId: string,
    configId?: number,
    filtros?: {
      fecha_desde?: string
      fecha_hasta?: string
      farmacia?: string
      provincia?: string
      promotor?: string
    }
  ): Promise<DashboardGraficos> => {
    const { data } = await apiClient.get(`${BASE_URL}/${grupoId}/graficos/`, {
      params: {
        ...(configId ? { config_id: configId } : {}),
        ...filtros,
      },
    })
    return data
  },

  getFiltros: async (grupoId: string, configId?: number): Promise<DashboardFiltroOpciones> => {
    const { data } = await apiClient.get(`${BASE_URL}/${grupoId}/filtros/`, {
      params: configId ? { config_id: configId } : undefined,
    })
    return data
  },

  getUsuarioDetalle: async (
    grupoId: string,
    userId: number
  ): Promise<UsuarioResumen> => {
    const { data } = await apiClient.get(
      `${BASE_URL}/${grupoId}/usuario/${userId}/`
    )
    return data
  },

  getComprobante: async (
    grupoId: string,
    comprobanteId: number
  ): Promise<ComprobanteDetalle> => {
    const { data } = await apiClient.get(
      `${BASE_URL}/${grupoId}/comprobante/${comprobanteId}/`
    )
    return data
  },

  buscar: async (
    grupoId: string,
    query: string,
    campo: string = 'nombre'
  ): Promise<BusquedaCrossDB> => {
    const { data } = await apiClient.get(`${BASE_URL}/${grupoId}/buscar/`, {
      params: { q: query, campo },
    })
    return data
  },

  exportar: async (
    grupoId: string,
    filtros?: Record<string, string>
  ): Promise<void> => {
    const response = await apiClient.get(`${BASE_URL}/${grupoId}/exportar/`, {
      params: filtros,
      responseType: 'blob',
    })
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `dashboard_${grupoId}.xlsx`)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  },
}
